import React from 'react'
import Form from '../components/Form'
import hipladeTemplate from '../../common/template'

function CheckListForm() {
  return <Form />
}

export default hipladeTemplate(CheckListForm)
